import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from 'configs/AppConfig';

const BASE_URL = API_BASE_URL;



//Sub Agreement functions
/**
 *
 * @param {FetchListParams} params
 * @returns {Promise<FetchLOIListResponse>}
 */
 export function requestSubAgreementList(params) {
    /**
     * @NOTE This limit is hard code for now because we need to implement the sorting nad filterting only at front end.
     *  In future we may remove it when sorting and filterting is implemented on backend
     */
    return fetch.get(`${BASE_URL}/api/app/sub-agreement`, {
        params: { limit: 10000 }
    });
}


/**
 *
 * @param {LOI Data} subAgreementData
 */
 export function requestCreateSubAgreement(subAgreementData) {
    return fetch.post(`${BASE_URL}/api/app/sub-agreement`, {
        ...subAgreementData
    });
}

/**
 *
 * @param {LOI Data} mainAgreementData
 */
export function requestUpdateSubAgreement(subAgreementData) {
    console.log(subAgreementData);
    const data = { ...subAgreementData };
    delete data['_id'];
    return fetch.put(`${BASE_URL}/api/app/sub-agreement/${subAgreementData._id}`, {
        ...data
    });
}